import {gql} from "@apollo/client";

export const GET_ITEM_CATEGORIES = gql`
  query item_categories($where: dashboard_reference_bool_exp!) {
    dashboard_reference(order_by: { reference_label: asc }, where: $where) {
      reference_value
      reference_label
    }
  }
`;


export const GET_ORDER_AHEAD_ITEMS = gql`
  query GetOrderAheadItems($where: items_order_ahead_bool_exp) {
    items_order_ahead(where: $where, order_by: { name: asc }) {
    category
    created_at
    description
    event_id
    id
    image
    is_active
    last_updated_by
    modifiers
    name
    price
    tax_percentage
    available_public_sale
    tax_type
    updated_at
    user {
      id
      username
    }
    event {
      id
      name
    }
    vendor_id
    vendor {
      id
      name
    }
  }
}
`;

export const GET_ORDER_AHEAD_ITEM = gql`
  query GetOrderAheadItem($id: Int!) {
    items_order_ahead_by_pk(id: $id) {
    category
    created_at
    description
    additional_email_description
    available_public_sale
    event_id
    id
    image
    is_active
    last_updated_by
    modifiers
    name
    price
    tax_percentage
    tax_type
    updated_at
    user {
      id
      username
    }
    event {
      id
      name
    }
    vendor_id
    vendor {
      id
      name
    }
    }
  }
`;
